/**
 * Persistenza delle ultime chat visualizzate nel browser (localStorage).
 * Mantiene al massimo le ultime 4.
 */

const STORAGE_KEY = "recent_chats";
const MAX_RECENT = 3;

export type RecentChatEntry = {
  id: string;
  title?: string | null;
  create_date: string;
};

function read(): RecentChatEntry[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (x): x is RecentChatEntry =>
        x != null &&
        typeof x === "object" &&
        typeof (x as RecentChatEntry).id === "string" &&
        typeof (x as RecentChatEntry).create_date === "string"
    );
  } catch {
    return [];
  }
}

function write(items: RecentChatEntry[]): void {
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(items.slice(0, MAX_RECENT))
    );
  } catch {
    // ignore
  }
}

/**
 * Restituisce le ultime chat visualizzate (max 4), ordine più recente prima.
 */
export function getRecentChats(): RecentChatEntry[] {
  return read();
}

/**
 * Registra una chat come "visualizzata" e la mette in testa alla lista.
 * Se già presente viene spostata in testa; si mantengono al massimo 4 voci.
 */
export function addRecentChat(chat: RecentChatEntry): void {
  const list = read();
  const without = list.filter((c) => c.id !== chat.id);
  const next = [
    { id: chat.id, title: chat.title ?? null, create_date: chat.create_date },
    ...without,
  ];
  write(next);
}
